import PropTypes from 'prop-types';
import Tooltip from '@/components/Tooltip';

export default function FormErrorIndicator({
  errorMessage,
}) {
  const content = (
    <button className="w-5 h-5 focus:outline-none cursor-pointer rounded-full focus:ring-2 focus:ring-red-100" type="button">
      <svg className="w-full h-full text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
      </svg>
    </button>
  );

  if (errorMessage === null) {
    return content;
  }

  return (
    <Tooltip tooltip={errorMessage}>
      {content}
    </Tooltip>
  );
}

FormErrorIndicator.defaultProps = {
  errorMessage: null,
};

FormErrorIndicator.propTypes = {
  errorMessage: PropTypes.string,
};
